export default "__VITE_ASSET__Ce2aYz$g__"